import {
  MessageBanner,
  MessageBannerType,
} from "@amzn/stencil-react-components/message-banner";
import IconAlertTriangleFillSmall from "@amzn/stencil-react-icons/icons/icon-alert-triangle-fill-small";
import React, { Children, ReactNode } from "react";

/**
 * An error message banner that will be used to notify about the issues occurred during the onboarding process.
 */
export default function ErrorBanner({
  children,
  boldFirst,
}: {
  children: ReactNode;
  boldFirst?: boolean;
}): JSX.Element {
  return (
    <MessageBanner
      type={MessageBannerType.Warning}
      dataTestId="idCheckErrorMsg"
      icon={
        <IconAlertTriangleFillSmall
          dataTestId="iconAlertTriangleFill"
          width={16}
        />
      }
    >
      {Children.map(children, (c, i) =>
        boldFirst && i == 0 ? <b>{c} </b> : c
      )}
    </MessageBanner>
  );
}
